  <template>
  <div class="yk-interactions__container__share yk-interactions__container__share-last-new-s is-line-left-solid">
    <div class="yk-interactions--header"
         style="padding-right:0px;">
      <span class="interaction-tips">投票</span>   
      <!-- <el-button @click="auditingActivity" size="small" v-if="userType==0">审核</el-button> -->
      <el-input placeholder="请输入名称查询"
                v-model="paperName"
                @keyup.enter.native='GetSchoolActivityList'>
        <i slot="suffix"
           class="el-input__icon el-icon-search"
           @click="GetSchoolActivityList()"></i>
      </el-input>
    </div>
    <div class="yk-class-activity-add-btn-wrapper" 
         @click="vote()">
      <i class="wl-icon-tianjia1"></i>
      <span>新增投票</span>
    </div>
     <!-- <div style="float: right;"
         class="yk-class-activity-add-btn-wrapper"
         @click="importDialogVisible=true">
      <i class="wl-icon-daoru1"></i>
      <span>学校资源库导入</span>
    </div> -->
     <div class="yt-interactions-line-division"></div>
    <div class="yk-interactions--inner"
         v-show="totalCount>0">
      <el-table ref="multipleTable"
                :data="list"
                stripe
                tooltip-effect="dark"
                style="width: 100%"
                empty-text=" ">
        <el-table-column label="序号"
                         type="index"
                         width="60">
        </el-table-column>
        <el-table-column prop="activityName"
                         label="名称">
        </el-table-column>
        <el-table-column prop="voteType"
                         label="类型"
                         width="100">
        </el-table-column>
        <el-table-column prop="CreateDisplayName"
                         label="创建人"
                         width="200">
        </el-table-column>
        <!-- <el-table-column prop="IsAuditing"
                         label="审核状态"
                         width="150">
        </el-table-column> -->
        <el-table-column label="操作"
                         width="180px">
          <template slot-scope="scope">
            <div class="yk-tem-button">
              <el-button size="mini"
                         v-show="scope.row.activityState !== '进行中'"
                         @click="editActivity(scope.row)"
                         icon="el-icon-edit"
                         type="primary"
                         title="编辑"></el-button>
              <!-- <el-button size="mini"
                         @click="editActivity(scope.row)"
                         icon="el-icon-view"
                         type="primary"
                         title="详情"></el-button> -->
              <el-button size="mini"
                         @click="deleteActivity(scope.row.id)"
                         icon="el-icon-delete"
                         type="danger"
                         title="删除"></el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-show="noDataShow"
         class="yk-nodata-source-content">
      <img src="~assets/images/the-last-new-nodata-imag.png"
           alt=""
           class="yk-prompt">
      <div class="sp-noData">暂无内容，请新增投票。</div>
    </div>
    <el-pagination background
                   @size-change="handleSizeChange"
                   @current-change="onPageChangeHandler"
                   :current-page="pageIndex"
                   :page-sizes="[5 , 10, 15, 20]"
                   :page-size="pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="totalCount"
                   v-show="totalCount>0">
    </el-pagination>

    <!-- 弹窗（头脑风暴、讨论、投票） -->
    <el-dialog :before-close="handleClose"
               title="投票"
               v-if="dialogFormVisibleBrainStormOrDiscuss"
               :visible.sync="dialogFormVisibleBrainStormOrDiscuss"
               :append-to-body="true"
               :close-on-click-modal="false"
               :close-on-press-escape="false">
      <el-form label-width="82px">
        <el-form-item label="名称：">
          <el-input class="input-with-select"
                    v-model="activityName"></el-input>
        </el-form-item>
        <el-form-item label="内容：">
          <el-input type="textarea"
                    :rows="6"
                    resize='none'
                    class="input-with-select"
                    v-model="activityContent"></el-input>
        </el-form-item>
        <el-form-item label="图片：">
          <oss-newthumbnail :url="urlAliyunOSS"
                            :files.sync="docJson"
                            format="image"
                            v-bind:count="8"></oss-newthumbnail>
            <!-- <img v-for="item in docJson" 
                 :key="item" 
                 :src="item" 
                 alt="" 
                 style="height: 146px;width: 146px;margin-right:5px;" /> -->
        </el-form-item>
        <div v-show="activityType == 6">
          <el-form-item label="投票类型：">
            <el-radio v-model="voteType"
                      label="正确错误">正确错误</el-radio>
            <el-radio v-model="voteType"
                      label="赞成反对">赞成反对</el-radio>
            <el-radio v-model="voteType"
                      label="单选">单选</el-radio>
            <el-radio v-model="voteType"
                      label="多选">多选</el-radio>
          </el-form-item>
          <div v-if="voteType=='单选'||voteType=='多选'"
               v-for="(li,index) in dataJson"
               :key="index">
            <el-form-item :label="li.name">
              <el-input placeholder="请输入内容"
                        style="float:left;width:240px"
                        v-model="li.content"></el-input>
              <el-button class="el-icon-delete"
                         style="margin-left:10px"
                         @click="deleteData(index)"></el-button>
            </el-form-item>
          </div>
          <el-button v-if="voteType=='单选'||voteType=='多选'"
                     type="primary"
                     style="float:left"
                     @click="addData">添加选项</el-button>
        </div>

      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="cancel()">取 消</el-button>
        <el-button type="primary"
                   @click="addoredit()"
                   :disabled="disabled">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSchoolActivityList,
  AddSchoolActivity,
  DeleteSchoolActivity,
  EditSchoolActivity
} from 'api/v1.manager.schoolactivity';
import { importActivity } from 'api/v1.design.PrepareImport';
import NewThumbnail from 'components/AliyunOSS/NewThumbnail.vue';
export default {
  components: {
    'oss-newthumbnail': NewThumbnail,
  },
  props: {
    schoolCourseId: {
      type: String,
      default: ''
    },
    courseId: {
      type: String,
      default: ''
    },
    userType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      importDialogVisible:false,
      word: '',
      // newCourseId: this.$route.params.courseId,
      /** 分页 */
      totalCount: -1,
      loadingShow: false,
      noDataShow: false,
      pageSize: 10,
      pageIndex: 1,
      /** 查询条件 */
      paperType: '3',
      /** 返回列表 */
      list: [],
      addName: '',
      /** */
      /* 颜色改变 */
      active: 1,
      myid: '',
      otherid: '',
      menuShow: false,
      dialogFormVisibleBrainStormOrDiscuss: false,
      activityName: '',
      activityContent: '',
      ActivityRemake: '',
      activityType: 6,
        urlAliyunOSS: '/api/design/osssign/getsign',
      docJson: '',
      disabled: false,
      dataJson: [
        { name: 'A', content: '' },
        { name: 'B', content: '' },
        { name: 'C', content: '' }
      ],
      activityId: '',
      activityRemake: '',
      voteType: '正确错误',
      paperName: '',
      seleteDate: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z'
      ],
      ids: []
    };
  },
  created() {
    this.GetSchoolActivityList(1);
  },
  computed: {
    auth() {
      let auth = this.$store.state.auth;
      return { ...auth };
    }
  },
  methods: {
    ImportActivity() {
      importActivity(this.ids, this.courseId).then(rst => {
        if (rst.code>0) {
          this.GetSchoolActivityList(1);
          this.importDialogVisible = false;
          this.$message.success(rst.code);
        } else {
          this.$message.warning(rst.code);
        }
      });
    },
    // 投票选项的删除
    deleteData(index) {
      this.dataJson.splice(index, 1);
      this.sortDateJson();
    },
    /** 返回列表 */
    GetSchoolActivityList(page) {
      this.loadingShow = true;
      getSchoolActivityList(
        this.schoolCourseId,
        this.courseId,
        6,
        this.paperName,
        page,
        this.pageSize
      ).then(rst => {
        this.list = rst.list;
        this.loadingShow = false;
        if (this.list.length === 0) {
          this.noDataShow = true;
        } else {
          this.noDataShow = false;
        }
        this.totalCount = rst.pagination.totalCount;
        this.pageSize = rst.pagination.pageSize;
        this.pageIndex = rst.pagination.pageIndex;
      });
    },
    handleClose(done) {
      done();
      this.cancel();
    },
    // 新增弹框
    vote() {
      this.activityType = 6;
      this.title = '投票';
      this.activityName = this.getNowFormatDate() + '的投票';
      this.dialogFormVisibleBrainStormOrDiscuss = true;
      this.disabled = false;
    },
    // 新增/编辑判断
    addoredit() {
      if (this.activityId === '') {
        this.disabled = true;
        this.AddFaceTeachActivity();
      } else {
        this.disabled = true;
        this.EditFaceTeachActivity();
      }
      // this.GetSchoolActivityList(this.pageIndex);
    },
    // 添加活动
    AddFaceTeachActivity() {
      var dataJson = JSON.stringify(this.dataJson);
      var voteType = 0;
      if (this.activityContent === '') {
        this.activityContent = '暂无内容';
      }
      if (this.voteType === '正确错误') voteType = 1;
      else if (this.voteType === '赞成反对') voteType = 2;
      else if (this.voteType === '单选') voteType = 3;
      else if (this.voteType === '多选') voteType = 4;

      if (this.activityType === 6 && this.activityContent === '') {
        this.$message.warning('投票内容不能为空');
        this.disabled = false;
        return false;
      }
      if (this.activityType === 6 && this.voteType === 0) {
        this.$message.warning('投票类型不能为空');
        this.disabled = false;
        return false;
      }
      if (
        (this.voteType === 3 || this.voteType === 4) &&
        this.dataJson.length === 0
      ) {
        this.$message.warning('投票选项不能未空');
        this.disabled = false;
      }
      var imageurl = '';
      if (typeof this.docJson === 'string') {
        imageurl = this.docJson;
      } else {
        this.docJson.forEach(function(url) {
          imageurl += url + ';';
        });
      }
      AddSchoolActivity(
        this.schoolCourseId,
        this.courseId,
        this.activityName,
        this.activityContent,
        voteType,
        dataJson,
        this.activityType,
        this.ActivityRemake,
        // this.docJson,
        imageurl,
        (this.questionType = 0),
        this.userType
      ).then(rst => {
        this.$message({
          type: 'warning',
          message: rst.msg
        });
        if (rst.code > 0) {
          this.activityId = '';
          this.cancel();
          this.GetSchoolActivityList();
        }
        this.disabled = false;
      });
    },
    // 编辑活动
    EditFaceTeachActivity() {
      var dataJson = JSON.stringify(this.dataJson);
      var voteType = 0;
      if (this.activityContent === '') {
        this.activityContent = '暂无内容';
      }
      if (this.voteType === '正确错误') voteType = 1;
      else if (this.voteType === '赞成反对') voteType = 2;
      else if (this.voteType === '单选') voteType = 3;
      else if (this.voteType === '多选') voteType = 4;
      var imageurl1 = '';
      if (typeof this.docJson === 'string') {
        imageurl1 = this.docJson;
      } else {
        this.docJson.forEach(function(url) {
          imageurl1 += url + ';';
        });
      }
      EditSchoolActivity(
        this.activityId,
        this.activityName,
        this.activityContent,
        this.ActivityRemake,
        (this.questionType = 0),
        voteType,
        dataJson,
        // this.docJson
        imageurl1
      ).then(rst => {
        this.$message({
          type: 'warning',
          message: rst.msg
        });
        if (rst.code > 0) {
          this.activityId = '';
          this.cancel();
        }
        this.disabled = false;
      });
      this.GetSchoolActivityList(this.pageIndex);
    },
    // 打开编辑活动弹窗
    editActivity(row) {
      this.disabled = false;
      this.activityId = row.id;
      this.activityType = 6;
      this.activityName = row.activityName;
      this.activityContent = row.activityContent;
      this.voteType = row.voteType;
      if (row.docJson.indexOf(';')>0) {
        // this.docJson = row.docJson.split(";");
        var aa = row.docJson.split(';');
        aa.pop();
        this.docJson = aa;
      } else {
        this.docJson = row.docJson;
      }
      this.dataJson =
        row.dataJson === '' ? this.dataJson : eval('(' + row.dataJson + ')');
      this.activityRemake = row.activityRemake;
      this.dialogFormVisibleBrainStormOrDiscuss = true;
    },
    onPageChangeHandler(page) {
      this.GetSchoolActivityList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetSchoolActivityList(1);
    },
    // 删除活动
    deleteActivity(id) {
      this.$confirm('此操作将删除当前活动, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 删除班级
          DeleteSchoolActivity(id).then(rst => {
            this.$message.warning(rst.msg);
            this.GetSchoolActivityList(this.pageIndex);
          });
        })
        .catch(() => {
          this.$message.info('已取消删除');
        });
    },
    goto: function(name, params) {
      this.$router.push({ name: name, params: params });
    },
    changeMenu: function() {
      this.menuShow = !this.menuShow;
    },
    // 获取当前时间方法
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = '-';
      var seperator2 = ':';
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = '0' + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate;
      }
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        ' ' +
        date.getHours() +
        seperator2 +
        date.getMinutes() +
        seperator2 +
        date.getSeconds();
      return currentdate;
    },
    // 取消弹窗方法
    cancel() {
      this.activityId = '';
      this.activityName = '';
      this.activityContent = '';
      (this.questionType = 1),
      (this.voteType = '正确错误'),
      (this.paperId = '');
      this.dataJson = [
        { name: 'A', content: '' },
        { name: 'B', content: '' },
        { name: 'C', content: '' }
      ];
      this.dialogFormVisibleSign = false;
      this.dialogFormVisibleBrainStormOrDiscuss = false;
      this.dialogFormVisibleSignOrQuestion = false;
      this.dialogFormVisiblePaper = false;
      this.docJson = '';
      this.GetSchoolActivityList(this.pageIndex);
    },
    // 投票选项添加
    addData() {
      this.dataJson.push({ name: '', content: '' });
      this.sortDateJson();
    },
    // 渲染选项集
    sortDateJson() {
      this.dataJson.forEach((element, index) => {
        element.name = this.seleteDate[index];
      });
    }
  }
};
</script>
<style lang="scss">
.yk-interactions__container__share {
  .yk-interactions--header {
    .yk-sourse--nemu-btn-wrapper-pre-dis {
      float: right;
      margin-left: 10px;
      width: 90px;
      height: 32px;
      background: rgba(63, 162, 255, 1);
      border-radius: 3px;
      line-height: 32px;
      text-align: center;
      color: #fff;
    }
  }
  .yk-class-activity-add-btn-wrapper {
    padding: 10px;
    margin-top: 20px;
    text-align: center;
    font-size: 17px;
    /* color: #fff; */
    border-radius: 10px;
    color:black;
    border: 1px dashed black;
    cursor: pointer;
    .wl-icon-tianjia1 {
      margin-right: 10px;
      font-size: 25px;
      border-radius: 50%;
      border: 1px solid black;
      vertical-align: -2px;
    }
    .wl-icon-daoru1 {
      margin-right: 10px;
      font-size: 25px;
      vertical-align: -2px;
    }
  }
  
}
.yk-interactions__container__share-last-new-s {
  .yk-btn-new-back-s {
    position: fixed;
    right: 30px;
    top: 10px;
    z-index: 2000;
    padding: 2px 10px;
    .wl-icon-fanhui2 {
      font-size: 29px;
    }
  }
  .el-input__inner {
    height: 32px;
  }
  .el-pagination__total {
    margin-right: 10px;
    font-weight: 400;
    //color: #fff;
  }
  .el-pagination__jump {
    margin-left: 24px;
    font-weight: 400;
    //color: #fff;
  }
}
</style>